<template>
  <div class="export-clip-modal-container">
    <Modal class="export-clip-modal modal-dark" :onClose="onClose">
      <div slot="header">{{$t('capture.export.title')}}</div>
      <form class="export-clip-modal__form" v-on:submit.prevent="onSubmit">
        <div class="section-export">
          <div class="list-group list-group-dark">
            <input
              class="form-control"
              :placeholder="$t('capture.export.placeholder')"
              ref="clipTitle"
              v-model="clipTitle" />
          </div>
        </div>
        <button type="submit"
          class="btn btn-primary float-right"
          @click="onSubmit">
          {{$t('capture.export.button')}}
        </button>
      </form>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/elements/Modal.vue';

export default {
  props: ['value', 'onClose', 'onExport'],
  components: {
    Modal,
  },
  data() {
    return {
      clipTitle: '',
    };
  },
  mounted() {
    this.$refs.clipTitle.focus();
  },
  methods: {
    async onSubmit() {
      await this.$emit('input', this.clipTitle);
      await this.onExport();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/variables.scss';

.export-clip-modal__form {
  padding: 1rem;
  height: 150px;
}

.section-export {
  margin: 0 0 20px;
}

.list-group-dark {
  .form-control {
    border: 1px solid #414141;
    background: #282828;
    color: #FFF;
  }
}
</style>
